// Camber reading = the phone's side-to-side tilt (gamma), the original behaviour that works
// whether the phone is upright or leaned back against the tire.
export function wheelLean(e) {
  return e.gamma == null ? null : e.gamma;
}

export const CASTER_FACTOR = 1.46; // 1 / (2·sin20°) for a ±20° sweep

// Coalesce high-rate sensor events (Android fires 100-200 Hz) into one call per animation frame.
export function rafThrottle(fn) {
  let frame = 0, last = null;
  const wrapped = (e) => {
    last = { beta: e.beta, gamma: e.gamma };
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; fn(last); });
  };
  wrapped.cancel = () => { if (frame) cancelAnimationFrame(frame); frame = 0; };
  return wrapped;
}

// Subscribe to tilt: prefers deviceorientation, falls back to devicemotion gravity
// (some Android builds never fire orientation). Calls onNoData if nothing arrives.
export function startTilt(onReading, onNoData, { waitMs = 1000, noDataMs = 3000 } = {}) {
  let mode = null;
  const t0 = Date.now();
  const ori = (e) => {
    if (e.beta == null || e.gamma == null || mode === "motion") return;
    mode = "orientation";
    onReading({ beta: e.beta, gamma: e.gamma, source: mode });
  };
  const mot = (e) => {
    const a = e.accelerationIncludingGravity;
    if (mode === "orientation" || !a || a.x == null || a.y == null || a.z == null) return;
    if (!mode && Date.now() - t0 < waitMs) return;
    const n = Math.hypot(a.x, a.y, a.z);
    if (n < 1) return;
    mode = "motion";
    const ux = a.x / n, uy = a.y / n, uz = a.z / n, d = 180 / Math.PI;
    onReading({ beta: Math.asin(Math.max(-1, Math.min(1, uy))) * d, gamma: Math.atan2(-ux, uz) * d, source: mode });
  };
  window.addEventListener("deviceorientation", ori);
  window.addEventListener("devicemotion", mot);
  const timer = setTimeout(() => { if (!mode && onNoData) onNoData(); }, noDataMs);
  return () => {
    clearTimeout(timer);
    window.removeEventListener("deviceorientation", ori);
    window.removeEventListener("devicemotion", mot);
  };
}

export const NO_SENSOR_HELP = {
  title: "No motion sensor data",
  description: "In Chrome tap ⋮ → Settings → Site settings → Motion sensors → allow this site, then reload. Also check Settings → Site settings → All sites for this site.",
  duration: 12000,
  action: { label: "Sensor check", onClick: () => { window.location.href = "/sensor-check"; } },
};
